import { FEDERATED_MICROSOFT_EMAIL_ENTITY_ATI } from '../../../types/entities';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';
import { OutlookMailIcon, OutlookMailIconBorderless, OutlookMailSearchResultIcon } from './icon';

export const outlookMail: ThirdPartyConfig = {
	displayName: 'Outlook Mail',
	id: 'outlook-mail',
	resourceType: ProductResourceTypes3P.OutlookMail,
	icon: get3PLogo(OutlookMailIcon, 'Outlook Mail', 'medium'),
	iconBorderless: get3PLogo(OutlookMailIconBorderless, 'Outlook Mail', 'small'),
	searchResultIcon: get3PLogo(OutlookMailSearchResultIcon, 'Outlook Mail', 'large'),
	integrationAri: 'ari:cloud:platform::integration/microsoft',
	requiresOauth: true,
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Message,
			{
				entities3P: [FEDERATED_MICROSOFT_EMAIL_ENTITY_ATI],
				subTypes3P: [],
			},
		],
	]),
	filters: ['lastUpdated', 'onlyTitleMatch'],
	isEnabled: () => true,
	isFederated: true,
};
